import React from 'react';
import './yujiezju.css';
import {  Layout, Avatar } from 'antd';
import { Link } from 'react-router-dom';
import myAvatar from './images/myAvatar.jpg';

const { Header, Content, Footer } = Layout;

const Page0 = () => {
    return(
        <Layout className='layout'>
            <Header className='header'>
                <h1>流 霜</h1>
            </Header>
            <Layout>
                <Content className='content'>
                    <br/><br/><br/>
                    
                    <Avatar
                        size={{
                        xs: 120,
                        sm: 150,
                        md: 180,
                        lg: 220,
                        xl: 250,
                        xxl: 400,
                        }}
                        src={myAvatar}
                    />      
                    <div >
                    <h1>欢迎来到我的个人主页！</h1>
                    <h2>虽然主页已经鸽了很久，但还得再鸽一段……</h2>
                    <h2>也许等期末结束再写吧</h2>
                    <h2>祝大家各种考试周都好运 ヾ(^∀^)ﾉ </h2>
                    <p>
                        如果不嫌弃，可以看看
                        <a href = 'http://track.yujiezju.run' className='href-red' target='_blank'>我的训练楼</a>                         
                    </p>
                    <p>
                        这里还有一些<Link to="/somepage" className='href-blue'>我写过的页面</Link>
                    </p>
                    <p style={{textAlign: 'center', paddingTop: '10px'}}>
                        <Link to="/friends" className='href-green'>友链-<l className="href-green-2">我和我的朋友们</l></Link>
                    </p>
                    </div>
                </Content>               
            </Layout>
            <Footer className='foot'>
            <a 
                href="https://beian.miit.gov.cn/" 
                target="_blank" 
                rel="noreferrer" 
                style={{color: 'gray'}}>
                滇ICP备2023016012号-2
            </a>
            </Footer>
        </Layout>
    );
}
export default Page0;